(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mcb-volume-discount-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('volume-pricing')) {
    customElements.define(
      'volume-pricing',
      class VolumePricing extends HTMLElement {
        constructor() {
          super();
          this.tiers = this.querySelectorAll('.volume-pricing-tier');
          this.init();
        }
    
        init() {
          for (const tier of this.tiers) {
            tier.addEventListener('click', this.handleTierClick.bind(this));
            tier.addEventListener('keydown', this.handleTierKeydown.bind(this));
          }
          
          // Set first tier (quantity 1) as selected by default
          if (this.tiers.length > 0) {
            this.selectTier(this.tiers[0]);
          }
        }
    
        handleTierClick(event) {
          const selectedTier = event.currentTarget;
          this.selectTier(selectedTier);
        }
    
        handleTierKeydown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const selectedTier = event.currentTarget;
            this.selectTier(selectedTier);
          }
        }
    
        selectTier(selectedTier) {
          for (const tier of this.tiers) {
            tier.classList.remove('is-selected');
            tier.setAttribute('aria-selected', 'false');
          }
          selectedTier.classList.add('is-selected');
          selectedTier.setAttribute('aria-selected', 'true');
          
          // Update quantity selector if it exists
          const quantity = selectedTier.dataset.quantity;
          const sectionId = this.dataset.sectionId;
          
          // Use specific selector based on section ID
          let quantityInput = null;
          if (sectionId) {
            quantityInput = document.querySelector(`#Quantity-${sectionId}`);
          }
          
          // Fallback to broader selector if specific one not found
          if (!quantityInput) {
            quantityInput = document.querySelector('input[name="quantity"]');
          }
          
          if (quantityInput) {
            quantityInput.value = quantity;
            // Trigger input and change events so DiscountKit and other listeners can respond
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          // Dispatch custom event for other components
          this.dispatchEvent(new CustomEvent('volume-pricing:tier-selected', {
            bubbles: true,
            detail: { quantity: parseInt(quantity, 10) }
          }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["volume-pricing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('volume-pricing')) {
    customElements.define(
      'volume-pricing',
      class VolumePricing extends HTMLElement {
        constructor() {
          super();
          this.tiers = this.querySelectorAll('.volume-pricing-tier');
          this.init();
        }
    
        init() {
          for (const tier of this.tiers) {
            tier.addEventListener('click', this.handleTierClick.bind(this));
            tier.addEventListener('keydown', this.handleTierKeydown.bind(this));
          }
          
          // Set first tier (quantity 1) as selected by default
          if (this.tiers.length > 0) {
            this.selectTier(this.tiers[0]);
          }
        }
    
        handleTierClick(event) {
          const selectedTier = event.currentTarget;
          this.selectTier(selectedTier);
        }
    
        handleTierKeydown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const selectedTier = event.currentTarget;
            this.selectTier(selectedTier);
          }
        }
    
        selectTier(selectedTier) {
          for (const tier of this.tiers) {
            tier.classList.remove('is-selected');
            tier.setAttribute('aria-selected', 'false');
          }
          selectedTier.classList.add('is-selected');
          selectedTier.setAttribute('aria-selected', 'true');
          
          // Update quantity selector if it exists
          const quantity = selectedTier.dataset.quantity;
          const sectionId = this.dataset.sectionId;
          
          // Use specific selector based on section ID
          let quantityInput = null;
          if (sectionId) {
            quantityInput = document.querySelector(`#Quantity-${sectionId}`);
          }
          
          // Fallback to broader selector if specific one not found
          if (!quantityInput) {
            quantityInput = document.querySelector('input[name="quantity"]');
          }
          
          if (quantityInput) {
            quantityInput.value = quantity;
            // Trigger input and change events so DiscountKit and other listeners can respond
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          // Dispatch custom event for other components
          this.dispatchEvent(new CustomEvent('volume-pricing:tier-selected', {
            bubbles: true,
            detail: { quantity: parseInt(quantity, 10) }
          }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
